<template>
  <div class="md-layout-item md-size-100">
    <md-field>
      <input type="text" ref="autocomplete" :placeholder="[[label]]" v-model="street_address" class="md-input"
        autocomplete="off" required />
    </md-field>
  </div>
</template>
<script>
export default {
  props: ['existingaddress', 'company', 'facility'],
  mounted() {
    console.log(this.existingaddress)
    if (this.existingaddress) {
      this.street_address = this.existingaddress
    }
    if (this.company) {
      this.label = 'Company Street Address*'
    }
    if (this.facility) {
      this.label = 'Facility Street Address*'
    }
    this.autocomplete = new google.maps.places.Autocomplete(
      (this.$refs.autocomplete),
      { types: ['geocode'] }
    );
    this.autocomplete.addListener('place_changed', () => {
      let place = this.autocomplete.getPlace();
      let ac = place.address_components;
      let lat = place.geometry.location.lat();
      let lon = place.geometry.location.lng();
      let city = ac[0]["short_name"];
      this.street_address = ac[0].long_name + ' ' + ac[1].long_name;
      this.$emit('childToParent', ac);
    });
  },
  data() {
    return {
      street_address: '',
      label: 'Job Site Street Address*'
    }
  },
  watch: {
    existingaddress: function () {
      console.log('here in aci')
      console.log(this.existingaddress)
      this.street_address = this.existingaddress
    }
  }
}

</script>
<style>
.search-location {
  display: block;
  width: 100%;
  margin: 0 auto;
  margin-top: 5vw;
  font-size: 20px;
  font-weight: 400;
  outline: none;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
}
</style>
